import { Directive, ElementRef, EventEmitter, Input, Output, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserProfileService } from '../services/user-profile.service';
import { StorageService } from '../services/storage.service';

@Directive({
    selector: '[appFeatureFlag]',
    standalone: false
})
export class FeatureFlagDirective {
  @Input('appFeatureFlag') featureName!: string;

  account_id: any;
  allowed_feature_flag: any;

  constructor( 
    private userService: UserProfileService, 
  private storageService: StorageService,
  private el: ElementRef, private renderer: Renderer2)  { }
  ngOnInit(): void {
    this.account_id = this.storageService.getAccountId() || null;
    this.userService.getOrderReviewConsent(this.account_id).subscribe(res => {
      const allowedFeatureFlag = res['content'].allowed_feature_flag || [];
      const ceBizProduct = allowedFeatureFlag.find(product => product.product_code === "CE_BIZ");
      let hasFeature = false;
      if (ceBizProduct) {
        hasFeature = ceBizProduct.allowed_features.some(feature => 
          feature.id.endsWith(this.featureName)
        );
      }
  
      console.log(`Feature "${this.featureName}" allowed:`, hasFeature);
  
      if (!hasFeature) {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      }
    });
  }
}
